import Carousel from "../components/Carousel";
export default class RotatingGrid {
  constructor(section) {
    const productSlider = section.el.querySelector('.product-carousel');
    const controls = section.el.querySelector('.product-carousel__controls');
    new Carousel({
      root: productSlider,
      type: 'distance',
      distance: 400,
      controlContainer: controls
    });
  }
}
